import {
  useModuleConfiguration,
  useModuleConfigurationSchema,
  useUpdateModuleConfiguration,
} from "../hooks/useModuleConfiguration";
import type { IntegrationModule } from "../types";
import { ConfigurationDialog } from "./ConfigurationDialog";

import type { ConfigurationContext } from "@/types/configuration";

interface ModuleConfigurationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  module: IntegrationModule;
  integrationName: string;
  context: ConfigurationContext;
}

export function ModuleConfigurationDialog({
  open,
  onOpenChange,
  module,
  integrationName,
  context,
}: ModuleConfigurationDialogProps) {
  const schemaQuery = useModuleConfigurationSchema(
    integrationName,
    module.moduleName,
    context,
    open,
  );

  const configQuery = useModuleConfiguration(
    integrationName,
    module.moduleName,
    context,
    open,
  );

  const updateMutation = useUpdateModuleConfiguration(context, {
    onSuccessClose: () => onOpenChange(false),
  });

  const handleSave = async (
    configurations: Record<string, string>,
    isActive: boolean,
  ) => {
    await updateMutation.mutateAsync({
      integrationName,
      moduleName: module.moduleName,
      configurations,
      isActive,
      currentIsActive: module.isActive,
    });
  };

  return (
    <ConfigurationDialog
      open={open}
      onOpenChange={onOpenChange}
      title={module.moduleDisplayName}
      description={module.moduleDescription}
      isActive={module.isActive}
      schemaQuery={schemaQuery}
      configQuery={configQuery}
      onSave={handleSave}
      isLoading={updateMutation.isPending}
      context={context}
      moduleName={module.moduleName}
      dependencies={module.dependencies}
      hasUnmetDependencies={module.hasUnmetDependencies}
      messages={module.messages}
      dependentModules={module.dependentModules}
      hasActiveDependentModules={module.hasActiveDependentModules}
    />
  );
}
